import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<PdfViewerComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private spinner: NgxSpinnerService) { }
    src;
  src1;
  pdfSrc;
fileType = "";
isImage = false;
  ispdf= false;
  noDataaa= false;
  showBtn = false;
    ngOnInit(): void {
      this.src = this.data
      if(this.src == undefined || this.src == ''){
        this.noDataaa = true;
        this.ispdf = false;
       this.isImage = false;
       this.showBtn=false;
      }
      if (this.src.startsWith('data:image')) {
        this.isImage = true;
        this.ispdf = false;
        this.noDataaa = false;
        this.showBtn = true
      }
      else { 
        this.isImage = false;
        this.noDataaa = false;
        this.ispdf = true;
        this.showBtn = true
        // this.src = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
        // this.src1 = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
      }
    
    }



    dowload()
    {
      const link=document.createElement("a");
       link.href=this.src;
       link.download='Download';
       link.click()
    }
  
}
